import React from 'react';
import { Flex } from 'antd';
import { getIcon, ICONS } from '../../icons';
import { COLOURS } from '../../colours';

const Conatiner = ({
  children,
  white = true,
  yellow = false,
  colour = "blue"
}) => {
  return (
    <Flex
      style={{ 
        borderRadius: '16px',
        background: yellow ? '#feeadf' : white && colour !== "blue" ? 'white' : colour,
        width: '100%'
      }}
      >
      { children }
    </Flex>
  );
};

export default Conatiner;
